import {
  PRICING_TIER_IDS,
  RECOMMENDED_PRICING_TIER,
} from "../../data/siteContent";
import { PRICING_TIER_PRICES_RUB } from "../../data/pricing";
import { useLocale } from "../../i18n/LocaleProvider";
import { formatRubPrice, formatUsdPrice } from "../../lib/exchangeRate";
import { useExchangeRate } from "../../providers/ExchangeRateProvider";
import { Section } from "../layout/Section";
import { BuyButton } from "../ui/BuyButton";

import styles from "./Pricing.module.css";

function formatTierPrice(
  rub: number,
  locale: "ru" | "en",
  rubToUsd: number | null,
  loading: boolean,
): string {
  if (locale === "ru") return formatRubPrice(rub);
  if (loading || rubToUsd === null) return "…";
  return formatUsdPrice(rub, rubToUsd);
}

export function Pricing() {
  const { locale, copy } = useLocale();
  const { rubToUsd, loading } = useExchangeRate();

  return (
    <Section
      id="pricing"
      dark
      title={copy.pricing.title}
      subtitle={copy.pricing.subtitle}
    >
      <div className={styles.grid}>
        {PRICING_TIER_IDS.map((id) => {
          const tier = copy.pricing.tiers[id];
          const recommended = id === RECOMMENDED_PRICING_TIER;
          const priceRub = PRICING_TIER_PRICES_RUB[id];

          return (
            <article
              key={id}
              className={`${styles.card} ${recommended ? styles.recommended : ""}`}
            >
              <div className={styles.cardHeader}>
                <h3 className={styles.cardTitle}>{tier.title}</h3>
                {recommended ? (
                  <span className={styles.badge}>
                    {copy.pricing.recommendedBadge}
                  </span>
                ) : null}
              </div>
              <p className={styles.price} aria-live="polite">
                {formatTierPrice(priceRub, locale, rubToUsd, loading)}
              </p>
              <ul className={styles.features}>
                {tier.features.map((feature) => (
                  <li key={feature}>{feature}</li>
                ))}
              </ul>
              <BuyButton variant={recommended ? "gold" : "secondary"}>
                {copy.cta.buy}
              </BuyButton>
            </article>
          );
        })}
      </div>

      {copy.pricing.exchangeRateNote ? (
        <p className={styles.exchangeRateNote}>
          {copy.pricing.exchangeRateNote}
        </p>
      ) : null}

      <p className={styles.footnote}>{copy.pricing.footnote}</p>
      <p className={styles.supportNote}>{copy.pricing.supportNote}</p>
    </Section>
  );
}
